module.exports = __webpack_public_path__ + "img/icon.731518ec.png";